<script lang="ts">
  import { onMount, type Snippet } from "svelte"
  import PlanHeader from "$app/Pages/Plans/PlanHeader.svelte"
  import RecognitionHeader from "$app/Pages/Plans/RecognitionHeader.svelte"
  import MainNav from "./MainNav.svelte"
  import Footer from "./Footer.svelte"
  import Flash from "./Flash.svelte"
  import Banner from "./Banner.svelte"
  import CommunityOnlyNav from "./CommunityOnlyNav.svelte"
  import { appStore } from "$app/store.svelte"
  import { toast } from "$app/utils/toast"
  import consumer from "$app/channels/consumer"
  import { notificationMessages } from "$app/constants"
  import { xhr } from "$app/utils"
  import { X } from "lucide-svelte"

  let props = $props()

  let {
    current_user,
    plan,
    subscription = {} as SubscriptionType,
    plan_users,
    app_banner,
    plans,
    onboarding,
    flash,
    children,
    params
  }: {
    current_user: UserType
    plan: PlanType
    subscription?: SubscriptionType
    plan_users: UserType[]
    app_banner: any
    plans: PlanType[]
    onboarding: any
    meeting: any
    flash: any
    children: Snippet
    params: any
  } = props

  appStore.current_user = current_user
  appStore.users = Object.values(plan_users).map((k, v) => k)
  appStore.plan = plan
  appStore.onboarding = onboarding
  appStore.params = params
  appStore.onboarding = onboarding || {}
  appStore.subscription = subscription

  plan_users = Object.values(plan_users)
    .filter((u: UserType) => !u.deleted && u.role !== "coach")
    .map((u: UserType) => {
      return { ...u, edit: false, showDetail: false }
    })
  appStore.users = plan_users

  let community_only: boolean = current_user.role === "community"
  let recognition_only: boolean = current_user.role === "recognition"

  const path = window.location.pathname
  let isAdmin = $state(false)
  if (/^\/plans\/\d+\/admin/.test(path)) {
    isAdmin = true
  }

  function listenForNotifications(): void {
    consumer.subscriptions.create(
      {
        channel: "WebNotificationsChannel",
        recipient_id: current_user.id
      },
      {
        connected() {
          console.log(
            "%cConnected to notifications channel",
            "font-weight: bold; color: green"
          )
        },
        disconnected() {},
        async received(data: any) {
          // Add new notification to the list
          if (data?.notification) {
            const user = data.sender
            const notification_res = await xhr.get(
              `/api/v1/notifications/${data.notification.id}`
            )

            if (notification_res?.data?.notification) {
              const notification = notification_res.data.notification
              appStore.notifications = [...appStore.notifications, notification]

              const msg = notificationMessages[notification.type]

              toast(msg, "success")
            }
            return
          }

          // Update notifications
          if (data?.notifications) {
            appStore.notifications = appStore.notifications.map((noti) => {
              const notification = data.notifications.find(
                (notifi: NotificationType) => notifi.id === noti.id
              )
              if (notification) {
                return { ...noti, ...notification }
              } else {
                return noti
              }
            })
          }
        }
      }
    )
  }

  let videoDialog = $state<HTMLDialogElement | undefined>()
  onMount(() => {
    listenForNotifications()

    if (!videoDialog) return

    videoDialog.addEventListener("mousedown", (event: MouseEvent) => {
      if (event.target === event.currentTarget) {
        videoDialog.close()
        videoDialog.querySelector("iframe").setAttribute("src", "")
      }
    })
  })
</script>

<svelte:head>
  {#if !isAdmin}
    <!--
    <script src="//code.tidio.co/a2fwhrkys2e7hihjxobw5b60tfiarzmp.js" async>
    </script>
    -->
  {/if}

  <script async src="https://www.googletagmanager.com/gtag/js?id=G-RXGMN2WVWL">
  </script>
  <script>
    window.dataLayer = window.dataLayer || []
    function gtag() {
      dataLayer.push(arguments)
    }
    gtag("js", new Date())
    gtag("config", "G-RXGMN2WVWL")
  </script>
</svelte:head>

<div id="main-layout">
  {#if community_only}
    <CommunityOnlyNav {plan} {current_user} />
  {:else}
    <MainNav {plan} {plans} {current_user} />
  {/if}

  {#if app_banner}
    <Banner {app_banner} />
  {/if}

  {#if plan?.id && !community_only}
    {#if recognition_only}
      <RecognitionHeader {plan} {onboarding} />
    {:else}
      <PlanHeader {plan} {onboarding} />
    {/if}
  {/if}

  {#if !community_only}
    <div id="plan-header"></div>
  {/if}

  <main class="bg-lwp-pale-grey">
    {#if !community_only}
      <Flash {flash} />
    {/if}

    <div class="max-w-7xl mx-auto">
      {@render children()}
    </div>
  </main>

  <Footer />
</div>

<dialog
  id="video-dialog"
  bind:this={videoDialog}
  class="video-dialog top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[700px] rounded-xl fixed"
>
  <div class="relative p-4 pt-8">
    <button
      class="absolute top-1 right-2"
      title="Close"
      onclick={() => {
        const dialog = document.querySelector("#video-dialog")
        if (!dialog) return
        // @ts-ignore
        dialog?.close()
        dialog.querySelector("iframe")?.setAttribute("src", "")
      }}
    >
      <X />
    </button>
    <div class="video-dialog-inner">
      <iframe
        src=""
        frameborder="0"
        class="w-full h-[500px]"
        allowfullscreen
        title="Video"
      ></iframe>
    </div>
  </div>
</dialog>

<style>
  #video-dialog::backdrop {
    background-color: rgba(0, 0, 0, 0.5);
  }
</style>
